import { getLabel } from '../../data/labels';
import { classIf } from '../../data/utils';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { useFavoriteTournaments, useFavoriteTournamentsDispatch } from '../favorite-tournaments/FavoriteTournamentsProvider';

export default function FavoriteTournamentToggle(props) {
    const favoriteTournaments = useFavoriteTournaments();
    const favoriteTournamentsDispatch = useFavoriteTournamentsDispatch();

    const onClick = () => favoriteTournamentsDispatch({type: 'toggle', id: props.uniqueId});

    return (
        <PinIcon
            className={"pin-toggle margine-dx pointer" + classIf(favoriteTournaments[props.uniqueId] === true, 'selected')}
            onClick={onClick}
            onMouseOver={props.onMouseOver}
            onMouseOut={props.onMouseOut}
            data-desc={getLabel('prematch_page.control_icon.favorite')}
        />
    );
}
